import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-issue-menu',
  templateUrl: './issue-menu.component.html',
  styleUrls: ['./issue-menu.component.css']
})
export class IssueMenuComponent implements OnInit {

  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Tickets')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Issues/issue-menu/issue-menu.component.ts